import { withActiveContextType } from '@/auth/activeAssignment';
import { getSessionUser } from '@/auth/session';
import { useSession } from '@/auth/SessionProvider';

/** The user's own picture (users.profile_img, a media URL), or null when there is none. */
export const userPictureUrl = (
  user: { profile_img?: unknown } | null | undefined,
): string | null => {
  const raw = user?.profile_img;
  if (typeof raw !== 'string') return null;
  const url = raw.trim();
  return url === '' || url === 'null' || url === 'undefined' ? null : url;
};

/**
 * The signed-in user of the in-memory session, read once (no React state):
 * for effects, callbacks and non-component code. `type` follows the active
 * role assignment. `{}` when nobody is signed in.
 */
export const readUserData = (): { userData: Record<string, any> } => {
  const user = getSessionUser();
  return { userData: user ? withActiveContextType(user) : {} };
};

const NO_USER: Record<string, any> = {};

/**
 * The signed-in user; `type` follows the active role assignment
 * (auth/activeAssignment.ts). Re-renders when the session changes
 * (`useSession()`). A React hook: call it only at the top of a component or
 * hook; elsewhere use readUserData().
 */
export const useUserData = (): { userData: Record<string, any> } => {
  const { user } = useSession();
  return { userData: user ?? NO_USER };
};
